export function asCurrency(amount) {
    return Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        maximumFractionDigits: 0,
    }).format(amount);
}

/**
 * Pounds and pence, for the schedule.
 *
 * Whole pounds are right everywhere else, but a schedule is a column of figures
 * that has to add up, and `£587 = £348 + £238` reads as broken arithmetic
 * rather than as rounding.
 */
export function asExactCurrency(amount) {
    return Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amount);
}

/** 100000 as 100,000. Empty for a NaN, which is what a cleared input gives. */
export function asGrouped(amount) {
    if (!Number.isFinite(amount)) {
        return '';
    }
    return Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(
        amount,
    );
}

/** Rates are held as fractions; 0.0422 reads as 4.22%, 0.05 as 5%. */
export function asPercent(fraction) {
    return `${+(fraction * 100).toFixed(2)}%`;
}

/**
 * The same span written out for prose: "7 months", "1 year", "1 year and 2
 * months". `yearsMonths` stays the compact form for the card stats, where the
 * column is narrow and every row reads the same shape.
 */
export function yearsMonthsLong(months) {
    const years = Math.floor(months / 12);
    const monthsPart = months % 12;
    const parts = [];

    if (years > 0) {
        parts.push(plural(years, 'year'));
    }
    if (monthsPart > 0 || years === 0) {
        parts.push(plural(monthsPart, 'month'));
    }

    return parts.join(' and ');
}

function plural(count, noun) {
    return `${count} ${noun}${count === 1 ? '' : 's'}`;
}

/**
 * The compact form for a table cell or a card stat: "11yr 6mo".
 *
 * `mo` rather than `m`, which reads as minutes — especially in a table where
 * the next column along is money a month.
 */
export function yearsMonths(months) {
    const years = Math.floor(months / 12);
    const monthsPart = months % 12;

    if (years === 0) {
        return `${monthsPart}mo`;
    }
    if (monthsPart === 0) {
        return `${years}yr`;
    }
    return `${years}yr ${monthsPart}mo`;
}
